import {
    CLEAR_STATE_DETAILS,
    CLEAR_STATE_LIST,
    SET_STATE_DETAILS,
    SET_STATE_FILTER_DATA,
    SET_STATE_LIST,
    STATE_CREATE_DIALOG_CLOSE,
    STATE_CREATE_DIALOG_OPEN,
    STATE_CREATE_ERROR,
    STATE_CREATE_ERROR_CLEAR,
    STATE_CREATE_PENDING,
    STATE_DETAILS_ERROR,
    STATE_DETAILS_ERROR_CLEAR,
    STATE_DETAILS_PENDING,
    STATE_EDIT_DIALOG_CLOSE,
    STATE_EDIT_DIALOG_OPEN,
    STATE_EDIT_ERROR,
    STATE_EDIT_ERROR_CLEAR,
    STATE_EDIT_PENDING,
    STATE_FILTER_DIALOG_CLOSE,
    STATE_FILTER_DIALOG_OPEN,
    STATE_LIST_ERROR,
    STATE_LIST_ERROR_CLEAR,
    STATE_LIST_PENDING,
} from "./constants"


const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    stateList: null,
    stateListCount: 0,
    isStateListPending: false,
    stateListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isStateFilterDialogOpen: false,
    stateFilterData: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    stateDetails: null,
    isStateDetailsPending: false,
    stateDetailsErrorMessage: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isStateCreateDialogOpen: false,
    isStateCreatePending: false,
    stateCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isStateEditDialogOpen: false,
    isStateEditPending: false,
    stateEditErrorMessage: null,
}

const states = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case STATE_LIST_PENDING: {
            return {
                ...state,
                isStateListPending: true,
                stateListErrorMessage: null,
            }
        }

        case SET_STATE_LIST: {
            const { stateList } = action.payload || {};
            return {
                ...state,
                stateList: stateList['value'],
                stateListCount: stateList['@odata.count'],
                isStateListPending: false,
                stateListErrorMessage: null,
            }
        }

        case STATE_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                stateListErrorMessage: errorMessage,
                isStateListPending: false,
                stateList: null,
                stateListCount: 0,
            }
        }

        case STATE_LIST_ERROR_CLEAR: {
            return {
                ...state,
                stateListErrorMessage: null,
                isStateListPending: false,
            }
        }
        case CLEAR_STATE_LIST: {
            return {
                ...state,
                stateList: null,
                stateListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case STATE_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isStateFilterDialogOpen: true,
            }
        }
        case STATE_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isStateFilterDialogOpen: false,
            }
        }

        case SET_STATE_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                stateFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case STATE_DETAILS_PENDING: {
            return {
                ...state,
                isStateDetailsPending: true,
                stateDetailsErrorMessage: null,
            }
        }

        case SET_STATE_DETAILS: {
            const { stateDetails } = action.payload || {};
            return {
                ...state,
                stateDetails: stateDetails,
                isStateDetailsPending: false,
                stateDetailsErrorMessage: null,
            }
        }

        case STATE_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                stateDetailsErrorMessage: errorMessage,
                isStateDetailsPending: false,
                stateDetails: null,
            }
        }

        case STATE_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                stateDetailsErrorMessage: null,
                // isStateDetailsPending: false,
            }
        }
        case CLEAR_STATE_DETAILS: {
            return {
                ...state,
                stateDetails: null,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case STATE_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isStateCreateDialogOpen: true,
            }
        }
        case STATE_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isStateCreateDialogOpen: false,
            }
        }

        case STATE_CREATE_PENDING: {
            return {
                ...state,
                isStateCreatePending: true,
                stateCreateErrorMessage: null,
            }
        }

        case STATE_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                stateCreateErrorMessage: errorMessage,
                isStateCreatePending: false,
            }
        }

        case STATE_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                stateCreateErrorMessage: null,
                isStateCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case STATE_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isStateEditDialogOpen: true,
            }
        }
        case STATE_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isStateEditDialogOpen: false,
            }
        }

        case STATE_EDIT_PENDING: {
            return {
                ...state,
                isStateEditPending: true,
                stateEditErrorMessage: null,
            }
        }

        case STATE_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                stateEditErrorMessage: errorMessage,
                isStateEditPending: false,
            }
        }

        case STATE_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                stateEditErrorMessage: null,
                isStateEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default states;